import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "ml-3" }
const _hoisted_3 = { class: "remove-notice mb-2" }

import { computed } from 'vue';
import { EMIT } from '@/enum';

interface PropsInterface {
  organizationNames: string[];
  caseManagerName: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RemoveOrganizationModal',
  props: {
    organizationNames: {},
    caseManagerName: {}
  },
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const organizationList = computed(() => {
  const names = props.organizationNames;
  return names.length > 1 ? `${names.slice(0, -1).join(', ')} and ${names.at(-1)}` : names[0];
});

const affectedPhrase = computed(() =>
  props.organizationNames.length > 1 ? 'those organizations' : 'that organization',
);

const onCancel = () => emit(EMIT.CANCEL);
const onAccept = () => emit(EMIT.ACCEPT);

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ConfirmAction = _resolveComponent("ConfirmAction")!

  return (_openBlock(), _createBlock(_component_ConfirmAction, {
    header: "Remove Organization",
    class: "remove-organization-modal",
    style: { width: '30rem' },
    "accept-label": "Remove Organization",
    "accept-type": "alert",
    onAccept: onAccept,
    onCancel: onCancel
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Icon, {
          name: "warning",
          class: "confirm-dialog-icon text-gray-600"
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, [
            _cache[0] || (_cache[0] = _createTextVNode(" Removing ", -1)),
            _createElementVNode("b", null, _toDisplayString(organizationList.value), 1),
            _cache[1] || (_cache[1] = _createTextVNode(" from ", -1)),
            _createElementVNode("b", null, _toDisplayString(__props.caseManagerName), 1),
            _createTextVNode(" will also remove them from all students in " + _toDisplayString(affectedPhrase.value) + ". ", 1)
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("p", { class: "remove-notice" }, "This cannot be undone.", -1))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})